import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { Answer, AnswerDTO } from "../types/answer";
import { CommonResultBreakdownDetails, CommonResultBreakdownDetailsDTO } from "./commonResultBreakdownDetails";

export interface MultiSelectResultV1DTO {
  answer: AnswerDTO;
  commonResultBreakdownDetails: CommonResultBreakdownDetailsDTO;
}

export class MultiSelectResultV1 {
  readonly isMultiSelectResultV1MultiSelectResultV1: boolean = true;

  readonly answer: Answer;
  readonly commonResultBreakdownDetails: CommonResultBreakdownDetails;


  constructor(
  answer: Answer, 
  commonResultBreakdownDetails: CommonResultBreakdownDetails
  ) {
    this.answer = answer;
    this.commonResultBreakdownDetails = commonResultBreakdownDetails;
  }

  static fromDTO(dto: MultiSelectResultV1DTO): MultiSelectResultV1 {
    const answer = Answer.fromDTO(getObject(dto, "answer", InvalidMultiSelectResultV1AnswerError));
    const commonResultBreakdownDetails = CommonResultBreakdownDetails.fromDTO(getObject(dto, "commonResultBreakdownDetails", InvalidMultiSelectResultV1CommonResultBreakdownDetailsError));
    return new MultiSelectResultV1(
      answer,
      commonResultBreakdownDetails
    );
  }

  toDTO(): MultiSelectResultV1DTO {
    const dto: MultiSelectResultV1DTO = {
        answer: this.answer.toDTO(),
        commonResultBreakdownDetails: this.commonResultBreakdownDetails.toDTO()
    };
    return dto;
  }
  }

MultiSelectResultV1.prototype.toString = function toString(): string {
  return `MultiSelectResultV1(answer='${this.answer}',commonResultBreakdownDetails='${this.commonResultBreakdownDetails}')`;
};

export class InvalidMultiSelectResultV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMultiSelectResultV1Error";
  }
}
export class InvalidMultiSelectResultV1AnswerError extends InvalidMultiSelectResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMultiSelectResultV1AnswerError";
  }
}

export class InvalidMultiSelectResultV1CommonResultBreakdownDetailsError extends InvalidMultiSelectResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMultiSelectResultV1CommonResultBreakdownDetailsError";
  }
}
